<template>
  <div>
     <vue-header/>
            <loading :active.sync="isLoading"
          :can-cancel="false"
          :width = "50"
          :height = "50"
          :is-full-page="false">
          </loading>
          <add-activity-modal ref="modalComponent"></add-activity-modal>
          <add-followup-modal ref="modalComponentFollow"></add-followup-modal>
     <div class="wd-container" style="margin-top: 15px;text-align:left;">
      <div class="container">
        <div class="card" style="margin-bottom: 0px;">
          <div class="card-header">
            Project Manager
          </div>
        </div>
        <div class="card-body" style="background-color:white; margin-bottom:20px;padding: 25px;">
          <div class="row">
            <multiselect  @select="selectOption" @remove="deselectOption" @input="updateUser" select-label="Click to select" deselect-label="Click to remove" v-model="selectedUser" :limit="3" :options="users" :multiple="true" :close-on-select="false"
                   :clear-on-select="false" placeholder="Select User" label="value" track-by="value">
                  </multiselect >
          </div>
        </div>

        <b-tabs pills card >
          <b-tab :title="'Project Manager Pipeline (' + pipelineCount+')'" active @click="tabSelect('pipeline')">
            <b-card-text>


          <div class="row">
          <span class="mb-2" style="margin-bottom:5px; margin-left:15px;">Filter by</span>
          </div>
          <div class="form-group" v-for="(input,k) in inputs" :id="k" :key="k">

            <div class="row">
              <div class="col-6" style="padding-right: 5px;padding-left: 5px;">
                <b-form-select :options="search_options_pipeline" @change="changeDrop(input)" type="text" style="font-size: 11px;"  class="form-control" v-model="input.name"></b-form-select>

                </div>
              <div class="col-5" style="padding-right: 5px;padding-left: 5px;" v-if="input.date_flag == 0"><input type="text"  class="form-control" v-model="input.value"></div>
               <div class="col-5" style="padding-right: 5px;padding-left: 5px;" v-if="input.date_flag == 1"><datetime placeholder = "From Date"  auto v-model="input.from" format="MM/dd/yyyy"></datetime><datetime  placeholder = "To Date"  v-model="input.to" format="MM/dd/yyyy" auto></datetime></div>
              <div class="col-1 " style="padding-right: 5px;padding-left: 5px;"> <span>
                  <i class="fas fa-minus-circle" style="color:red;" @click="remove(k)" v-show="k == inputs.length-1 && inputs.length != 1"></i>
                  <i class="fas fa-minus-circle" style="color:red;margin-top: 12px;" @click="remove(k)" v-show="k != inputs.length-1"></i>
                  <i class="fas fa-plus-circle" style="color:#6495ed;" @click="add(input.id)" v-show="k == inputs.length-1 && inputs.length != 1"></i>
                  <i class="fas fa-plus-circle" style="    margin-top: 12px;color:#6495ed;" @click="add(input.id)" v-show="inputs.length == 1"></i>
              </span>
              </div>
            </div>
          </div>
          <div class="row">
          <span class="mb-2" style="margin-bottom:5px; margin-left:15px;">Sort by</span>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-6" style="padding-right: 5px;padding-left: 5px;">
                <b-form-select :options="search_options_pipeline" type="text" style="font-size: 11px;"  class="form-control" v-model="sort.name"></b-form-select>
              </div>
              <div class="col-6" style="padding-right: 5px;padding-left: 5px;">
                <b-form-select :options="sort_options" type="text" style="font-size: 11px;"  class="form-control" v-model="sort.order"></b-form-select>
              </div>
            </div>
          </div>
          <div class="row">
              <div class="col-2"></div>
            <div class="form-group col-4" style="text-align: center;margin-top:8px;padding-right: 5px;padding-left: 5px;">
                <button type="submit" class="btn btn-save" @click="applyFilter"> Apply  </button>
              </div>
              <div class="form-group col-4" style="text-align: center;margin-top:8px;padding-right: 5px;padding-left: 5px;">
                <button type="submit" class="btn btn-save" style="background-color: white;
color: black;" @click="resetFilter"> Reset  </button>
              </div>
              <div class="col-2"></div>
            </div>
          <!-- </b-collapse> -->

          <b-card-text class="mt-3">
              <table id="job_table" class="display" style="width:100%">
                <thead>
                    <tr>
                        <th class="all">Status</th>
                        <th class="all">Job</th>
                        <th class="none">Account</th>
                        <th class="none">Amount</th>
                        <th class="none">Priority</th>
                        <th class="none">Deadline</th>
                        <th></th>
                    </tr>
                </thead>
            </table>
          </b-card-text>

            </b-card-text>
          </b-tab>



          <b-tab :title="'Follow Ups (' + followCount+')'" @click="tabSelect('follow')">
            <b-card-text>

               <div class="row">
                  <span class="mb-2" style="margin-bottom:5px; margin-left:15px;">Filter by</span>
                  </div>
                  <div class="form-group" v-for="(input,k) in inputs_follow" :id="k" :key="k">


                    <div class="row">
                      <div class="col-6" style="padding-right: 5px;padding-left: 5px;">
                        <b-form-select :options="search_options_follow" @change="changeDropFollow(input)" type="text" style="font-size: 11px;"  class="form-control" v-model="input.name"></b-form-select>

                        </div>
                      <div class="col-5" style="padding-right: 5px;padding-left: 5px;" v-if="input.date_flag == 0"><input type="text"  class="form-control" v-model="input.value"></div>
                      <div class="col-5" style="padding-right: 5px;padding-left: 5px;" v-if="input.date_flag == 1"><datetime placeholder = "From Date"  auto v-model="input.from" format="MM/dd/yyyy"></datetime><datetime  placeholder = "To Date"  v-model="input.to" format="MM/dd/yyyy" auto></datetime></div>
                      <div class="col-1 " style="padding-right: 5px;padding-left: 5px;"> <span>
                          <i class="fas fa-minus-circle" style="color:red;" @click="removeFollow(k)" v-show="k == inputs.length-1 && inputs.length != 1"></i>
                          <i class="fas fa-minus-circle" style="color:red;margin-top: 12px;" @click="removeFollow(k)" v-show="k != inputs.length-1"></i>
                          <i class="fas fa-plus-circle" style="color:#6495ed;" @click="addFollow(input.id)" v-show="k == inputs.length-1 && inputs.length != 1"></i>
                          <i class="fas fa-plus-circle" style="    margin-top: 12px;color:#6495ed;" @click="addFollow(input.id)" v-show="inputs.length == 1"></i>
                      </span>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                  <span class="mb-2" style="margin-bottom:5px; margin-left:15px;">Sort by</span>
                  </div>
                  <div class="form-group">
                    <div class="row">
                      <div class="col-6" style="padding-right: 5px;padding-left: 5px;">
                        <b-form-select :options="search_options_follow" type="text" style="font-size: 11px;"  class="form-control" v-model="sort_follow.name"></b-form-select>
                      </div>
                      <div class="col-6" style="padding-right: 5px;padding-left: 5px;">
                        <b-form-select :options="sort_options" type="text" style="font-size: 11px;"  class="form-control" v-model="sort_follow.order"></b-form-select>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                      <div class="col-2"></div>
                    <div class="form-group col-4" style="text-align: center;margin-top:8px;padding-right: 5px;padding-left: 5px;">
                        <button type="submit" class="btn btn-save" @click="applyFilterFollow"> Apply  </button>
                      </div>
                      <div class="form-group col-4" style="text-align: center;margin-top:8px;padding-right: 5px;padding-left: 5px;">
                        <button type="submit" class="btn btn-save" style="background-color: white;
        color: black;" @click="resetFilterFollow"> Reset  </button>
                      </div>
                      <div class="col-2"></div>
                    </div>
                  <!-- </b-collapse> -->

                  <b-card-text class="mt-3">
                      <table id="job_follow_table" class="display" style="width:100%">
                        <thead>
                            <tr>
                                <th class="all">Job</th>
                                <th class="all">Activity</th>
                                <th class="none">Deadline</th>
                                <th class="none">Assign To</th>
                                <th class="none">Action</th>
                                <th></th>
                            </tr>
                        </thead>
                    </table>
                  </b-card-text>


            </b-card-text>
          </b-tab>

          <b-tab :title="'Activity Stream (' + activityCount+')'" @click="tabSelect('activity')">
            <b-card-text>

          <div class="row">
          <span class="mb-2" style="margin-bottom:5px; margin-left:15px;">Filter by</span>
          </div>
          <div class="form-group" v-for="(input,k) in inputs_activity" :id="k" :key="k">

           <div class="row">
                      <div class="col-6" style="padding-right: 5px;padding-left: 5px;">
                        <b-form-select :options="search_options_activity" @change="changeDropActivity(input)" type="text" style="font-size: 11px;"  class="form-control" v-model="input.name"></b-form-select>

                        </div>
                      <div class="col-5" style="padding-right: 5px;padding-left: 5px;" v-if="input.date_flag == 0"><input type="text"  class="form-control" v-model="input.value"></div>
                      <div class="col-5" style="padding-right: 5px;padding-left: 5px;" v-if="input.date_flag == 1"><datetime placeholder = "From Date"  auto v-model="input.from" format="MM/dd/yyyy"></datetime><datetime  placeholder = "To Date"  v-model="input.to" format="MM/dd/yyyy" auto></datetime></div>
                      <div class="col-1 " style="padding-right: 5px;padding-left: 5px;"> <span>
                          <i class="fas fa-minus-circle" style="color:red;" @click="removeActivity(k)" v-show="k == inputs.length-1 && inputs.length != 1"></i>
                          <i class="fas fa-minus-circle" style="color:red;margin-top: 12px;" @click="removeActivity(k)" v-show="k != inputs.length-1"></i>
                          <i class="fas fa-plus-circle" style="color:#6495ed;" @click="addActivity(input.id)" v-show="k == inputs.length-1 && inputs.length != 1"></i>
                          <i class="fas fa-plus-circle" style="    margin-top: 12px;color:#6495ed;" @click="addActivity(input.id)" v-show="inputs.length == 1"></i>
                      </span>
                      </div>
                    </div>
          </div>
          <div class="row">
          <span class="mb-2" style="margin-bottom:5px; margin-left:15px;">Sort by</span>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-6" style="padding-right: 5px;padding-left: 5px;">
                <b-form-select :options="search_options_activity" type="text" style="font-size: 11px;"  class="form-control" v-model="sort_activity.name"></b-form-select>
              </div>
              <div class="col-6" style="padding-right: 5px;padding-left: 5px;">
                <b-form-select :options="sort_options" type="text" style="font-size: 11px;"  class="form-control" v-model="sort_activity.order"></b-form-select>
              </div>
            </div>
          </div>
          <div class="row">
              <div class="col-2"></div>
            <div class="form-group col-4" style="text-align: center;margin-top:8px;padding-right: 5px;padding-left: 5px;">
                <button type="submit" class="btn btn-save" @click="applyFilterActivity"> Apply  </button>
              </div>
              <div class="form-group col-4" style="text-align: center;margin-top:8px;padding-right: 5px;padding-left: 5px;">
                <button type="submit" class="btn btn-save" style="background-color: white;
color: black;" @click="resetFilterActivity"> Reset  </button>
              </div>
              <div class="col-2"></div>
            </div>
          <!-- </b-collapse> -->

          <b-card-text class="mt-3">
              <table id="job_activity_table" class="display" style="width:100%">
                <thead>
                    <tr>
                        <th class="all">Timestamp</th>
                        <th class="all">Job</th>
                        <th class="none">Activity</th>
                        <th class="none">User</th>
                        <th class="none">Type</th>
                        <th></th>
                    </tr>
                </thead>
            </table>
          </b-card-text>
            </b-card-text>
          </b-tab>
          <b-tab :title="'Schedules '"  @click="openModalSchedule"></b-tab>
          </b-tabs>
          <b-modal ref="schedule-modal" title="Schedules"  hide-footer>
            <Calendar :calendar_options_blackout="blackout_calendars" :calendar_options="calendar_options"  />
          </b-modal>
          <b-modal ref="my-modal"  >
            <template v-slot:modal-header="{  }">

             <div class="row" style="width: 100%;">
              <div class="col-12">
                <div >
                  <i class="material-icons float-left" style="font-size: 42px;margin-right: 8px;color: #303032;">
                    perm_contact_calendar
                  </i>
                </div>
                <div class="wd-modal-subheader">
                  <h3 style="font-size: 18px;font-weight: 300;color: #303032;margin: 0;">{{resolveDialogData.activity}}</h3>
                  <p v-if="resolveDialogData.contacts_profile_data" style="font-size: 14px;
                    font-weight: 300;
                    color: #9E9E9E;
                    margin: 0;">Contact With :
                    {{resolveDialogData.contacts_profile_data.first_name}}
                    {{resolveDialogData.contacts_profile_data.last_name}}</p>
                  <p v-if="resolveDialogData.user_profile_data" style="font-size: 14px;
                    font-weight: 300;
                    color: #9E9E9E;
                    margin: 0;">Assign To
                    :{{resolveDialogData.user_profile_data.first_name}}
                    {{resolveDialogData.user_profile_data.last_name}}</p>
                </div>
                <div class="wd-model-subheader" style="padding-top:10px; color:#585858;">
                  <h6><strong>Job: {{resolveDialogData.job_name}}</strong></h6>
                </div>
              </div>
            </div>
            </template>
            <div class="wd-modal-body p-l-20 p-r-20">
            <div class="wd-resolve-followup">
              <div class="wd-resolve-followup-note">
                <p style="margin-top: 0px; margin-bottom: 20px">
                  {{resolveDialogData.note}} - {{ resolveDialogData.created_at}} by
                  <span v-if="resolveDialogData.user_name" style="margin-right:5px;">{{resolveDialogData.user_name}}</span>
                  <img v-if="resolveDialogData.user_profile_data && resolveDialogData.user_profile_data.avatar"
                       :src="resolveDialogData.user_profile_data.avatar">
                  <img v-else src="/img/avatar.jpg">
                </p>

                <ul type="disc">
                  <div v-for="notes in resolveDialogData.note_data">
                    <li style="color: #9E9E9E;">{{notes.note}} - {{ notes.updated_at }} by
                      {{ notes.user_profile_data.first_name }}
                      {{notes.user_profile_data.last_name }}
                      <img class="ui avatar image" v-if="notes.user_profile_data.avatar"
                           :src="notes.user_profile_data.avatar">
                      <img v-else src="/img/avatar.jpg">
                    </li>
                  </div>
                </ul>
              </div>
              <button class="btn btn-save" type="submit" @click="resolveJob(resolveDialogData)">
                Resolve
              </button>
              <hr/>
              <div class="row">
                <div class="col-md-12">
                  <h4 style="margin-bottom: 10px">
                    Add Note to Follow Up
                  </h4>
                </div>
                <div class="col-md-12">
                  <div class="wd-textarea">
                    <label for="followUpNote">Note</label>
                    <textarea id="followUpNote" v-model="resolveNote" rows="5"></textarea>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="wd-checkbox p-b-10" style="margin-top: 16px">
                    <label>
                      <input type="checkbox" v-model="reassignCheckbox">
                      <span class="checkbox-decorator">
                        <span class="check"></span>
                      </span>
                      Re-Assign Follow Up?
                    </label>
                  </div>
                </div>
                <div class="col-md-6" style="margin-bottom: 16px;" v-if="reassignCheckbox">
                  <div class="wd-v-select">
                    <label class="wd-v-select-label">User</label>
                    <b-form-select  type="text" style="font-size: 11px;"  class="form-control" v-model="assigned">
                      <option v-for="(val, indexOpt) in followupAssigned"
                            :key="val.id"
                            v-bind:value="val.id"
                        >
                            {{ val.value }}
                        </option>
                    </b-form-select>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="wd-checkbox p-b-10">
                    <label>
                      <input type="checkbox" v-model="newDeadlineCheckbox">
                      <span class="checkbox-decorator">
                              <span class="check"></span>
                            </span>
                      New Deadline?
                    </label>
                  </div>
                </div>
                <div class="col-md-6" v-if="newDeadlineCheckbox">
<!--                  <div class="wd-webix-input m-t-0">
                    <label for="" class="wd-v-select-label">Deadline</label>
                    <webix-ui :config="deadlineDateConfig" :value="deadlineDate"></webix-ui>
                </div>-->
                  <div class="wd-text-input">
                  <label>Deadline</label>
                  <!-- <date-picker style="margin-bottom: 20px;" v-model="deadlineDate" :first-day-of-week="1"
                  lang="en" name="deadline"
                  format="MM/DD/YYYY"></date-picker> -->
                  <datetime v-model="deadlineDate" style="margin-bottom: 20px;" format="MM/dd/yyyy"></datetime>
                  </div>
                </div>
                <div class="col-12">
                  <button class="btn btn-save" type="submit"
                          :disabled="resolveNote == '' && !reassignCheckbox && !newDeadlineCheckbox"
                          @click="addNote(resolveDialogData)">
                    Save
                  </button>
                </div>
              </div>

            </div>
          </div>

            <template v-slot:modal-footer="{  }">
              <b-button size="sm" class="btn btn-save" variant="danger" style="background-color: white; color: black;" @click="closeModal">
                Close
              </b-button>
            </template>
          </b-modal>




          
          
          <div class="btn-group-fab" role="group" aria-label="FAB Menu" v-if="addFlag">
                <div>

                  <button @click="openFollowupAddModal"  type="button" class="btn btn-main btn-primary has-tooltip" data-placement="left" title="Menu"> <i class="fa fa-plus" style="margin: 5px 0px 0px 0px;"></i> </button>
                </div>
              </div>
              <div class="btn-group-fab" role="group" aria-label="FAB Menu" v-if="addFlagActivity">
                <div>

                  <button @click="openActivityAddModal"  type="button" class="btn btn-main btn-primary has-tooltip" data-placement="left" title="Menu"> <i class="fa fa-plus" style="margin: 5px 0px 0px 0px;"></i> </button>
                </div>
              </div>

      </div>
     </div>
  </div>
</template>

<script>
import Vue from 'vue';
import CommonConstants from '@/constants/constants.js'
import moment from 'moment'
import Loading from 'vue-loading-overlay';
import AddActivityModal from "./AddActivityModal";
import AddFollowupModal from "./AddFollowupModal";
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import Calendar from './CalendarGlobal.vue';
import Multiselect from 'vue-multiselect'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import _ from 'lodash';
let user = JSON.parse(localStorage.getItem('userData'))
let foreman_flag = false;
export default {
  name: 'JobListing',
  components : {Loading,AddActivityModal,AddFollowupModal,Datetime, Multiselect ,VueBootstrapTypeahead,Calendar},
  data() {
    return {
      constants: CommonConstants,
      isLoading:false,
      pipelineCount:'',
      followCount: '',
      job_options: [],
      activityCount:'',
      activities :[],
      contacts:[],
      users :[],
      resolveDialogData : '',
      followUpData : [],
      followupWithoutJob : false,
      calendar_options: [],
        colors : [
        "#3b83c0", "#FA8072", "#0E743F",
        "#7FFF00", "#ADFF2F", "#FF0000", "#00FF7F", "#00FF7F",
        "#ADD8E6", "#6B8E23", "#9ACD32", "#32CD32", "#00FF00",
        "#3b83c0", "#FA8072", "#0E743F",
        "#7FFF00", "#ADFF2F", "#FF0000", "#00FF7F", "#00FF7F",
        "#ADD8E6", "#6B8E23", "#9ACD32", "#32CD32", "#00FF00",
        "#3b83c0", "#FA8072", "#0E743F",
        "#7FFF00", "#ADFF2F", "#FF0000", "#00FF7F", "#00FF7F",
        "#ADD8E6", "#6B8E23", "#9ACD32", "#32CD32", "#00FF00",
        "#3b83c0", "#FA8072", "#0E743F",
        "#7FFF00", "#ADFF2F", "#FF0000", "#00FF7F", "#00FF7F",
        "#ADD8E6", "#6B8E23", "#9ACD32", "#32CD32", "#00FF00",
        "#3b83c0", "#FA8072", "#0E743F",
        "#7FFF00", "#ADFF2F", "#FF0000", "#00FF7F", "#00FF7F",
        "#ADD8E6", "#6B8E23", "#9ACD32", "#32CD32", "#00FF00",
        "#3b83c0", "#FA8072", "#0E743F",
        "#7FFF00", "#ADFF2F", "#FF0000", "#00FF7F", "#00FF7F",
        "#ADD8E6", "#6B8E23", "#9ACD32", "#32CD32", "#00FF00",
        "#3b83c0", "#FA8072", "#0E743F",
        "#7FFF00", "#ADFF2F", "#FF0000", "#00FF7F", "#00FF7F",
        "#ADD8E6", "#6B8E23", "#9ACD32", "#32CD32", "#00FF00",
        "#3b83c0", "#FA8072", "#0E743F",
        "#7FFF00", "#ADFF2F", "#FF0000", "#00FF7F", "#00FF7F",
        "#ADD8E6", "#6B8E23", "#9ACD32", "#32CD32", "#00FF00",
        "#3b83c0", "#FA8072", "#0E743F",
        "#7FFF00", "#ADFF2F", "#FF0000", "#00FF7F", "#00FF7F",
        "#ADD8E6", "#6B8E23", "#9ACD32", "#32CD32", "#00FF00",
            ],
      jobs: [],
      followUpActivity: '',
      followUpType: '',
      followUpContact: '',
      followUpUser: '',
      followUpDeadline: '',
      followUpJob: '',
      followUpNote: '',
      addFlag : false,
      blackout_calendars :[],
      addFlagActivity: false,
      reassignCheckbox: false,
      newDeadlineCheckbox: false,
      followupAssigned:[],
      assigned : JSON.parse(localStorage.getItem('userData')).id,
      deadlineDate :'',
      resolveNote: '',
      cust_1 : localStorage.getItem('cust1'),
      cust_2 : localStorage.getItem('cust2'),
      cust_3 : localStorage.getItem('cust3'),
      cust_drop1 : localStorage.getItem('cust_drop1'),
      cust_drop2 : localStorage.getItem('cust_drop2'),
      cust_drop3 : localStorage.getItem('cust_drop3'),
      inputs: [{name: '',value:'',id:0,date_flag:0,from:'',to:''}],
      inputs_activity: [{name: '',value:'',id:0,date_flag:0,from:'',to:''}],
      inputs_follow: [{name: '',value:'',id:0,date_flag:0,from:'',to:''}],
      sort : {name : "", order:''},
      sort_activity : {name : "", order:''},
      sort_follow : {name : "", order:''},
      sort_options : ['Desc','Asc'],
      search_options_pipeline : [{ value: '', text: 'Select Field',disabled: true },{value: 'job_number', text: 'Job Number'},{value: 'name', text: 'Name'},{value: 'account_name', text: 'Account Name'},{value: 'status', text: 'Status'},{value: 'amount', text: 'Amount'},{value: 'estimator_priority', text: 'Priority'},{value: 'estimator_deadline', text: 'Deadline'}],
      selectedUser: {id: user.id, value: user.first_name + ' ' + user.last_name},
      search_options_activity : [{ value: '', text: 'Select Field',disabled: true },{value: 'job_number', text: 'Job Number'},{value: 'timestamp', text: 'Timestamp'},{value: 'name', text: 'Name'},{value: 'activity', text: 'Activity'},{value: 'user', text: 'User'},{value: 'type', text: 'Type'}],
      selectedUser: {id: user.id, value: user.first_name + ' ' + user.last_name},
      search_options_follow : [{ value: '', text: 'Select Field',disabled: true },{value: 'job_number', text: 'Job Number'},{value: 'name', text: 'Name'},{value: 'activity', text: 'Activity'},{value: 'deadline', text: 'Deadline'},{value: 'assign_to', text: 'Assign To'}],
      selectedUser: {id: user.id, value: user.first_name + ' ' + user.last_name},
      users_add: [],
      postSelectedUser : ''

    }
  },
  mounted : function(){
    let self = this;
    self.header = {
        'Content-type': "application/json",
        'token': localStorage.getItem('token')
    }
    self.followupModal();
    self.getJobHeader();
    self.loadDTJobs();
    self.getAllCalendar();
    self.getAllCalendarBlackout();
    self.loadDTJobsActivity();
    self.loadDTJobsFollow();
    self.openWorkOrder();
    this.getJobData();
    this.$root.$on('callAPI', function (data) {
            console.log("data recieved");
            self.loadDTJobsFollow()
            self.loadDTJobsActivity()
        });
    if(user.roles && user.roles[0].role_id == 47){
      foreman_flag = true;
    }
      self.deadlineDate = moment().format('YYYY-MM-DD')
      // self.assigned = JSON.parse(localStorage.getItem('userData')).id + ' ' + JSON.parse(localStorage.getItem('userData')).id;
    localStorage.setItem('previous_url','foreman');
  },
  methods :{
    selectOption(option , id){
      let self = this
      self.postSelectedUser = 'init';
      if(option.id == 0){
          self.postSelectedUser = 'all';
      }
    },
    selectedJob (query){
      let self = this;
      self.followUpJob = query.job_id.toString()
    },
    getJobData(){
      let self = this;
      axios.get(self.constants.api_url + 'jobs-input-ajax',{
        headers: {
            'Content-type': "application/json",
            'token': localStorage.getItem('token')
            }
        })
          .then(function (res) {
            self.loader = true
            let t = res.data.data
            var tmp = {}
            var jobs = []
            for (var d of t) {
              tmp = {id: d.job_id, value: d.description.toString().substring(2) + ' - '+d.title}
              jobs.push(tmp)
            }
            localStorage.setItem('jobs_status_json', JSON.stringify(jobs));
            self.jobs = jobs;
          })
          .catch(e => {
            Vue.$toast.error(e, {
            position: 'top'
            });
          })
    },
    deselectOption(option , id){
      let self = this
      self.postSelectedUser = 'init';
      if(option.id == 0){
          self.postSelectedUser = 'remove';
      }
    },
    updateUser(){
      let self  = this;
      if(self.postSelectedUser == 'all')
        self.selectedUser = self.users;
      else if(self.postSelectedUser == 'remove')
        self.selectedUser = [];
      self.loadDTJobs();

    },
    changeDrop(val){
      let self= this;
        this.inputs.forEach(function(element,key) {
          if(element.id == val.id){
            if(val.name == 'updated_at' || val.name == 'bid_date' || val.name == "estimator_deadline"){
              self.inputs[key].date_flag = 1;
            }else{
              self.inputs[key].date_flag = 0;
            }
          }
        });
    },
    changeDropActivity(val){
      let self= this;
        this.inputs_activity.forEach(function(element,key) {
          if(element.id == val.id){
            if(val.name == 'updated_at' || val.name == 'bid_date' || val.name == "timestamp"){
              self.inputs_activity[key].date_flag = 1;
            }else{
              self.inputs_activity[key].date_flag = 0;
            }
          }
        });
    },
    changeDropFollow(val){
      let self= this;
        this.inputs_follow.forEach(function(element,key) {
          if(element.id == val.id){
            if(val.name == 'updated_at' || val.name == 'bid_date' || val.name == "deadline"){
              self.inputs_follow[key].date_flag = 1;
            }else{
              self.inputs_follow[key].date_flag = 0;
            }
          }
        });
    },
    resetFilter(){
      this.inputs = [{name: '',value:'',id:0,date_flag:0,from:'',to:''}];
      this.sort = {name : "", order:''};
      this.loadDTJobs();
    },
    resetFilterActivity(){
      this.inputs_activity = [{name: '',value:'',id:0,date_flag:0,from:'',to:''}];
      this.sort_activity = {name : "", order:''};
      this.loadDTJobsActivity();
    },
    resetFilterFollow(){
      this.inputs_follow = [{name: '',value:'',id:0,date_flag:0,from:'',to:''}];
      this.sort_follow = {name : "", order:''};
      this.loadDTJobsFollow();
    },
    applyFilter(){
      let option_val = [];
      this.inputs.forEach(element => {
        if(element.name != '')
          option_val.push(element.name)
        if(element.from != '')
          element.from = moment(element.from).format('YYYY-MM-DD');
        if(element.to != '')
          element.to = moment(element.to).format('YYYY-MM-DD');
      });
      if(new Set(option_val).size !== option_val.length){
        Vue.$toast.error('Please remove duplicate field', {
            position: 'top'
            });
      }else{
        this.loadDTJobs();
      }

    },
    applyFilterActivity(){
      let option_val = [];
      this.inputs_activity.forEach(element => {
        if(element.name != '')
          option_val.push(element.name)
        if(element.from != '')
          element.from = moment(element.from).format('YYYY-MM-DD');
        if(element.to != '')
          element.to = moment(element.to).format('YYYY-MM-DD');
      });
      if(new Set(option_val).size !== option_val.length){
        Vue.$toast.error('Please remove duplicate field', {
            position: 'top'
            });
      }else{
        this.loadDTJobsActivity();
      }

    },
    applyFilterFollow(){
      let option_val = [];
      this.inputs_follow.forEach(element => {
        if(element.name != '')
          option_val.push(element.name)
        if(element.from != '')
          element.from = moment(element.from).format('YYYY-MM-DD');
        if(element.to != '')
          element.to = moment(element.to).format('YYYY-MM-DD');
      });
      if(new Set(option_val).size !== option_val.length){
        Vue.$toast.error('Please remove duplicate field', {
            position: 'top'
            });
      }else{
        this.loadDTJobsFollow();
      }

    },
    add(index) {
      let self = this;
        self.inputs.push({ name: '',value: '',id : index+1, date_flag:0,from:'',to:''});
    },
    remove(index) {
        this.inputs.splice(index, 1);
    },
    addActivity(index) {
      let self = this;
        self.inputs_activity.push({ name: '',value: '',id : index+1, date_flag:0,from:'',to:''});
    },
    removeActivity(index) {
        this.inputs_activity.splice(index, 1);
    },
    addFollow(index) {
      let self = this;
        self.inputs_follow.push({ name: '',value: '',id : index+1, date_flag:0,from:'',to:''});
    },
    removeFollow(index) {
        this.inputs_follow.splice(index, 1);
    },
    loadDTJobs(){
      var self = this;
      //self.isLoading = false;
      $("#job_table").DataTable({
        processing: true,
        serverSide: true,
        responsive: {
            details: {
                type: 'column',
                target: -1,
                renderer: function ( api, rowIdx, columns ) {
                    var data = $.map( columns, function ( col, i ) {
                      if(col.title =='Name' ){
                        return col.hidden ?
                            '<tr data-dt-row="'+col.rowIndex+'" data-dt-column="'+col.columnIndex+'">'+
                                '<td><b>'+col.title+':'+'</b></td> '+
                                '<td style="white-space: normal;">'+col.data+'</td>'+
                            '</tr>' :
                            '';
                      }else{
                         return col.hidden ?
                            '<tr data-dt-row="'+col.rowIndex+'" data-dt-column="'+col.columnIndex+'">'+
                                '<td><b>'+col.title+':'+'<b></td> '+
                                '<td >'+col.data+'</td>'+
                            '</tr>' :
                            '';
                      }
                    } ).join('');

                    return data ?
                        $('<table/>').append( data ) :
                        false;
                }
            }
        },
        buttons: [
            {
                extend: 'colvis',
                columns: ':not(.noVis)',
                collectionLayout: 'fixed two-column',
                text: "<i class='fas fa-cog' ></i>"+"  Show/Hide Columns"
            }
        ],
        "ordering": false,
        columnDefs: [ {
            className: 'control',
            orderable: false,
            targets:   -1,
        },
        // {
        //     targets: 32,
        //     className: 'noVis'
        // }
        ],
        "dom": '<"top">rit<"bottom"p><"clear">',
        "paging":   true,
        "pagingType": "simple_numbers",
        "pageLength": 25,
        destroy: true,
        colReorder: true,
        language: {
          emptyTable: "No record found.",
          search: "INPUT",
          searchPlaceholder: "Search records",
          processing: 'Loading...',
          // oPaginate: {
          //   sNext: '<i class="fas fa-angle-double-right"></i>',
          //   sPrevious: '<i class="fas fa-angle-double-left"></i>'
          // },
          sLengthMenu:
            "<label class='label_dropdown_dt'>Per page</label> MENU"
        },
        ajax: {
          headers: self.header,
          url: self.constants.api_url + 'dashboard/project-manager/jobs/search/pwa',
          "data": function ( d ) {
             d.search_value = self.inputs;
             d.sort_value = self.sort;
             d.selected_user = self.selectedUser;
          },
          dataType: "json",
          dataSrc: function (result) {
            //self.allTagsModel = result.data.approved_timesheets;
            self.pipelineCount = result.recordsTotal;
            //self.isLoading = false;
            return result.data;
          }
        },
        columns: [
          {
            render: function(data, type, full, meta) {
              return (
                full.status ? full.status.charAt(0).toUpperCase() + full.status.slice(1) : ''
              );
            }
          },
          { data: "job", width : "50%",
            render: function(data, type, full, meta) {
              return (
                "<a href='/job/"+full.id+"'>"+full.job_name+"</a>"
              );
            }
          },
          { data: "account_name" },

          { data: "amount" ,
            render: function(data, type, full, meta) {
            return (
                full.amount ? '<span  style="color:green;">$ '+full.amount +'</span>': '<span style="color:red;">Bid Not Created Yet</span>'
              );
            }
          },
          { data: "estimator_priority" ,
            render: function(data, type, full, meta) {
              return (
                full.estimator_priority ? full.estimator_priority : 'None'
              );
            }
          },
          { data: "estimator_deadline" ,
            render: function(data, type, full, meta) {
              return (
                full.estimator_deadline ? full.estimator_deadline : 'None'
              );
            }
          },

          {
            render: function(data, type, full, meta) {
              return (
                ''
              );
            }
          }
        ]
      });

      $("#job_table").on("page.dt", function() {
        $("html, body").animate({ scrollTop: 0 }, "slow");
        $("th:first-child").focus();
      });
    },
    loadDTJobsActivity(){
      var self = this;
//self.isLoading = false;
      $("#job_activity_table").DataTable({
        processing: true,
        serverSide: true,
        responsive: {
            details: {
                type: 'column',
                target: -1,
                renderer: function ( api, rowIdx, columns ) {
                    var data = $.map( columns, function ( col, i ) {
                      if(col.title =='Name' ){
                        return col.hidden ?
                            '<tr data-dt-row="'+col.rowIndex+'" data-dt-column="'+col.columnIndex+'">'+
                                '<td><b>'+col.title+':'+'</b></td> '+
                                '<td style="white-space: normal;">'+col.data+'</td>'+
                            '</tr>' :
                            '';
                      }else{
                         return col.hidden ?
                            '<tr data-dt-row="'+col.rowIndex+'" data-dt-column="'+col.columnIndex+'">'+
                                '<td><b>'+col.title+':'+'<b></td> '+
                                '<td >'+col.data+'</td>'+
                            '</tr>' :
                            '';
                      }
                    } ).join('');

                    return data ?
                        $('<table/>').append( data ) :
                        false;
                }
            }
        },
        buttons: [
            {
                extend: 'colvis',
                columns: ':not(.noVis)',
                collectionLayout: 'fixed two-column',
                text: "<i class='fas fa-cog' ></i>"+"  Show/Hide Columns"
            }
        ],
        "ordering": false,
        columnDefs: [ {
            className: 'control',
            orderable: false,
            targets:   -1,
        },
        // {
        //     targets: 32,
        //     className: 'noVis'
        // }
        ],
        "dom": '<"top">rit<"bottom"p><"clear">',
        "paging":   true,
        "pagingType": "simple_numbers",
        "pageLength": 25,
        destroy: true,
        colReorder: true,
        language: {
          emptyTable: "No record found.",
          search: "INPUT",
          searchPlaceholder: "Search records",
          processing: 'Loading...',
          // oPaginate: {
          //   sNext: '<i class="fas fa-angle-double-right"></i>',
          //   sPrevious: '<i class="fas fa-angle-double-left"></i>'
          // },
          sLengthMenu:
            "<label class='label_dropdown_dt'>Per page</label> MENU"
        },
        ajax: {
          headers: self.header,
          url: self.constants.api_url + 'dashboard/estimator/activities/search/pwa',
          "data": function ( d ) {
             d.search_value = self.inputs_activity;
             d.sort_value = self.sort_activity;
             d.selected_user = self.selectedUser;
          },
          dataType: "json",
          dataSrc: function (result) {
            //self.allTagsModel = result.data.approved_timesheets;
            self.activityCount = result.recordsTotal;
            //self.isLoading = false;
            return result.data;
          }
        },
        columns: [
          {
            data : "created_at"
          },
          { data: "job", width : "50%",
            render: function(data, type, full, meta) {
              return (
                "<a href='/job/"+full.id+"'>"+full.job_name+"</a>"
              );
            }
          },
          { data: "activity" },
          { data: "user_name" },
          { data: "type" },
          {
            render: function(data, type, full, meta) {
              return (
                ''
              );
            }
          }
        ]
      });

      $("#job_table").on("page.dt", function() {
        $("html, body").animate({ scrollTop: 0 }, "slow");
        $("th:first-child").focus();
      });
    },
    loadDTJobsFollow(){
      var self = this;
     // self.isLoading = false;
      $("#job_follow_table").DataTable({
        processing: true,
        serverSide: true,
        responsive: {
            details: {
                type: 'column',
                target: -1,
                renderer: function ( api, rowIdx, columns ) {
                    var data = $.map( columns, function ( col, i ) {
                      if(col.title =='Name' ){
                        return col.hidden ?
                            '<tr data-dt-row="'+col.rowIndex+'" data-dt-column="'+col.columnIndex+'">'+
                                '<td><b>'+col.title+':'+'</b></td> '+
                                '<td style="white-space: normal;">'+col.data+'</td>'+
                            '</tr>' :
                            '';
                      }else{
                         return col.hidden ?
                            '<tr data-dt-row="'+col.rowIndex+'" data-dt-column="'+col.columnIndex+'">'+
                                '<td><b>'+col.title+':'+'<b></td> '+
                                '<td >'+col.data+'</td>'+
                            '</tr>' :
                            '';
                      }
                    } ).join('');

                    return data ?
                        $('<table/>').append( data ) :
                        false;
                }
            }
        },
        buttons: [
            {
                extend: 'colvis',
                columns: ':not(.noVis)',
                collectionLayout: 'fixed two-column',
                text: "<i class='fas fa-cog' ></i>"+"  Show/Hide Columns"
            }
        ],
        "ordering": false,
        columnDefs: [ {
            className: 'control',
            orderable: false,
            targets:   -1,
        },
        // {
        //     targets: 32,
        //     className: 'noVis'
        // }
        ],
        "dom": '<"top">rit<"bottom"p><"clear">',
        "paging":   true,
        "pagingType": "simple_numbers",
        "pageLength": 25,
        destroy: true,
        colReorder: true,
        language: {
          emptyTable: "No record found.",
          search: "INPUT",
          searchPlaceholder: "Search records",
          processing: 'Loading...',
          sLengthMenu:
            "<label class='label_dropdown_dt'>Per page</label> MENU"
        },
        ajax: {
          headers: self.header,
          url: self.constants.api_url + 'dashboard/project_manager/follow_ups/search/pwa',
          "data": function ( d ) {
             d.search_value = self.inputs_follow;
             d.sort_value = self.sort_follow;
             d.selected_user = self.selectedUser;
             d.dashboard = "estimator";
          },
          dataType: "json",
          dataSrc: function (result) {
            self.followCount = result.recordsTotal;
            self.followUpData = result.data;
            self.isLoading = false;
            return result.data;
          }
        },
        columns: [

          { data: "job", width : "50%",
            render: function(data, type, full, meta) {
              return (
                "<a href='/job/"+full.id+"'>"+full.job_name+"</a>"
              );
            }
          },
          { data: "activity" },
          { data: "deadline" },
          { data: "assign_to" },
          {
            render: function(data, type, full, meta) {
              return (
                '<i class="fa fa-info-circle" aria-hidden="true" id="info_button" data-log-id="'+ full.id +'" style="color: #6495ed; cursor: pointer;font-size:18px;"></i>'
              );
            }
          },
          {
            render: function(data, type, full, meta) {
              return (
                ''
              );
            }
          }
        ]
      });

      $("#job_follow_table").on("page.dt", function() {
        $("html, body").animate({ scrollTop: 0 }, "slow");
        $("th:first-child").focus();
      });

    },
    followupModal (){
      let self = this;
      $(document).on("click","#info_button", function (e) {
        let id = $(e.target).data('log-id');
        self.OpenFollowupModal(id)
      })
    },

    OpenFollowupModal(id){
      this.followUpData.forEach(val =>{
        if(val.id == id){
          this.resolveDialogData = val;
        }
      });
      this.$refs['my-modal'].show();
    },
    openModalSchedule(){
      this.$refs['schedule-modal'].show();
    },
    openFollowupAddModal(){

      this.$refs.modalComponentFollow.show();
      // this.$refs['my-modal-add'].show();
    },
    openActivityAddModal(){

    // this.$refs['my-modal-activity-add'].show();
    this.$refs.modalComponent.show();
    },
    getAllCalendar(){
          let self = this;
          axios.post(self.constants.api_url + 'dashboard/project-manager/calendar-data', {}, {
          headers: {
            'Content-type': "application/json",
            'token': localStorage.getItem('token')
              }
            })
              .then(function (response) {
                if (response.data.flag) {
                  self.calendar_options = response.data.data;
                  if(self.calendar_options.length > 0){
                      self.calendar_options.forEach((element,key) => {
                        element.color = element.color ? element.color : '#2196f3';
                      });
                    }
                  self.calendar_options.forEach(val => {
                    self.calendarCheck.push(val.id)
                  })
                }
              })
        },
        getAllCalendarBlackout(){
          let self = this;
          axios.post(self.constants.api_url + 'dashboard/project-manager/blackout-calendar-data', {}, {
          headers: {
            'Content-type': "application/json",
            'token': localStorage.getItem('token')
              }
            })
              .then(function (response) {
                if (response.data.flag) {
                  self.blackout_calendars = response.data.data;
                  if(self.calendar_options.length > 0){
                      self.calendar_options.forEach((element,key) => {
                        element.color = element.color ? element.color : '#2196f3';
                      });
                    }
                  self.calendar_options.forEach(val => {
                    self.calendarCheck.push(val.id)
                  })
                }
              })
        },
    closeFollowupAddModal(){
      let self = this;
      self.followUpActivity = '';
      self.followUpType = '';
      self.followupWithoutJob = '';
      self.followUpContact = '';
      self.followUpUser = '';
      self.followUpDeadline = '';
      self.followUpNote = '';
      this.$refs['my-modal-add'].hide();
    },
    getJobHeader(){
        let self = this
        axios.get(self.constants.api_url + 'dashboard/project-manager/' + user.id, {headers : self.header})
          .then(function (response) {
            console.log(response.data.data);
            self.users = response.data.data.project_manager_select;
            localStorage.setItem('estmUsers', JSON.stringify(self.users))
            self.followupAssigned = response.data.data.users;
            self.activities = response.data.data.activities_select;
            //self.contacts = response.data.data.contacts;
            self.users_add = response.data.data.project_manager_select;
          })
      },
    openWorkOrder (){
      let self = this;
      $(document).on("click","#rework_work_order", function (e) {
        let id = $(e.target).data('log-id');
        self.printReworkWorkOrder(id)
      })
    },
    printReworkWorkOrder: function (id) {
        let self = this;
        let url = this.constants.api_url + 'job/rework-order/' + id + '/' + localStorage.getItem('token')
        axios.get(url ,this.request, { headers: this.header }).then(res => {
          var win = window.open()
          if (win) {
            win.document.body.innerHTML = res.data
          } else
            self.$toasted.show('Popup Blocked, allow it to view content in new tab.', self.errorToast)

        }).catch(e =>
          self.$toasted.show(e, self.successToast),
        )
      },
      contactSearch: _.debounce(function (d) {
        let self = this
        self.jobs = []
        if (d) {
          axios.get(this.constants.api_url + 'contact-input-ajax/' + d, {
          headers: {
            'Content-type': "application/json",
            'token': localStorage.getItem('token')
          }
        })
            .then(function (res) {
              self.contacts = res.data.data
            })
        }
      }, 600),
      resolveJob(data){
         let self = this;
        var formData = new FormData();
        let temp = {
          "job_note_id": data.id,
        };
        formData.append('job_note_id', data.id);
        //before resolving follow up if there is any note the user wants to add save it before resolving
        if(self.resolveNote != ''){
            self.addNote(data);//adding the follow up note before resolving the follow up
        }
        axios.post(this.constants.api_url + 'follow-up/resolve', formData, {
          headers: {
            'Content-type': "application/json",
            'token': localStorage.getItem('token')
          }
        })
          .then(function (response) {
            self.resolveDialog = false;
            self.resolveNote = '';
            self.reassignCheckbox = false;
            self.assigned = '';
            self.newDeadlineCheckbox = false;
            self.deadlineDate = moment().format('MM/DD/YYYY');
            Vue.$toast.success("FollowUp resolved successfully ", {
                position: 'top'
              });
            self.loadDTJobsFollow();
            self.$refs['my-modal'].hide()
          })
          .catch(function (error) {
            Vue.$toast.error("Can't resolve", {
                position: 'top'
              });
          })

      },
      closeModal (){
        this.$refs['my-modal'].hide()
      },
      validater(data) {
        return data === '' || data === null || data === undefined
      },
      addNote: function (data) {
        let self = this;
        let temp = {}
        let flag = true
        let finaldate = moment(self.deadlineDate).format('MM/DD/YYYY')
        if (self.reassignCheckbox) {
          if (self.validater(self.assigned)) {
            Vue.$toast.error("Select User", {
                position: 'top'
              });
            flag = false;
          }
        }
        let assigned = ''
        if (typeof self.assigned === 'string') {
          assigned = JSON.parse(localStorage.getItem('userData')).id
        } else if (typeof self.assigned === 'object') {
          assigned = self.assigned.id

        }
        if (self.reassignCheckbox && self.newDeadlineCheckbox) {
          temp = {
            "job_id": data.job_id,
            "job_note_id": data.id,
            "note": self.resolveNote,
            "assigned": assigned,
            "deadline": finaldate,
          }

          var formData = new FormData();
          formData.append('job_id', data.job_id);
          formData.append('job_note_id', data.id);
          formData.append('note', self.resolveNote);
          formData.append('assigned', assigned);
          formData.append('deadline', finaldate);
        } else if (self.reassignCheckbox && !self.newDeadlineCheckbox) {
          temp = {
            "job_id": data.job_id,
            "job_note_id": data.id,
            "note": self.resolveNote,
            "assigned": assigned,
            "deadline": '',
          }

          var formData = new FormData();
          formData.append('job_id', data.job_id);
          formData.append('job_note_id', data.id);
          formData.append('note', self.resolveNote);
          formData.append('assigned', assigned);
          formData.append('deadline', '');
        } else if (self.newDeadlineCheckbox && !self.reassignCheckbox) {
          temp = {
            "job_id": data.job_id,
            "job_note_id": data.id,
            "note": self.resolveNote,
            "assigned": '',
            "deadline": finaldate,
          }

          var formData = new FormData();
          formData.append('job_id', data.job_id);
          formData.append('job_note_id', data.id);
          formData.append('note', self.resolveNote);
          formData.append('assigned', '');
          formData.append('deadline', finaldate);
        } else {
          temp = {
            "job_id": data.job_id,
            "job_note_id": data.id,
            "note": self.resolveNote,
            "assigned": '',
            "deadline": '',
          }

          var formData = new FormData();
          formData.append('job_id', data.job_id);
          formData.append('job_note_id', data.id);
          formData.append('note', self.resolveNote);
          formData.append('assigned', '');
          formData.append('deadline', '');
        }
        if (flag) {
          axios.post(this.constants.api_url + 'follow-up/note/create', formData, {
            headers: {
              'Content-type': "application/json",
              'token': localStorage.getItem('token')
            }
          })
            .then(function (response) {
              self.resolveDialog = false;
              self.resolveNote = '';
              self.reassignCheckbox = false;
              self.newDeadlineCheckbox = false;
              self.deadlineDate = moment().format('MM/DD/YYYY');
              Vue.$toast.success("Note added successfully", {
                position: 'top'
              });
              self.loadDTJobsFollow();
              self.$refs['my-modal'].hide()

            })
            .catch(function (error) {
              Vue.$toast.error("Can't add note", {
                position: 'top'
              });
            })
        }
      },
      createFollowUp() {
        let self = this
        var data = {}
        data['activity'] = this.followUpActivity;
        data['type'] = this.followUpType;

        data['job_id'] = this.followupWithoutJob ? '' : this.followUpJob;


        data['contact'] = this.followUpContact.id;
        data['assigned'] = this.followUpUser;
        data['deadline'] = (this.followUpDeadline) ? moment(this.followUpDeadline).format('MM/DD/YYYY') : null;
        data['note'] = this.followUpNote;
        data['follow-up'] = 1;//changes by rohan at 31 oct 2018
        axios.post(self.constants.api_url + 'job/notes/create', data, {
          headers: {
            'Content-type': "application/json",
            'token': localStorage.getItem('token')
          }
        })
          .then(function (response) {
            if (response.data.flag) {
              Vue.$toast.success("Follow Up added successfully", {
                position: 'top'
              });
              self.followUpActivity = '';
              self.followUpType = '';
              self.followupWithoutJob = '';
              self.followUpContact = '';
              self.followUpUser = '';
              self.followUpDeadline = '';
              self.followUpNote = '';
              self.loadDTJobsFollow();
              self.$refs['my-modal-add'].hide()
              self.isLoading = false;
              console.log("Data emited from add follow up===");
            }
          })
          .catch(function (error) {
            self.$toasted.show(error, self.errorToast)
          })
      },
      validaterAddFollow() {
        let flag = false
        if (this.followUpActivity === '' || this.followUpActivity === null) {
          flag = false
          Vue.$toast.error("Select Activity", {
                position: 'top'
              });
        } else if (this.followUpType === '' || this.followUpType === null) {
          flag = false
          Vue.$toast.error("Select Type", {
                position: 'top'
              });
        } else if (!this.followupWithoutJob) {
          if (this.followUpJob === '' || this.followUpJob === null) {
            flag = false
            Vue.$toast.error("Select Job", {
                position: 'top'
              });
          } else {
            flag = true
          }

        } else {
          flag = true
        }
        if (flag) {
          this.isLoading = true;
          this.createFollowUp()
        }
      },
      jobSearch(d) {
        let self = this
        if (d) {
          axios.get(this.constants.api_url + 'jobs-input-ajax/' + d, {
          headers: {
            'Content-type': "application/json",
            'token': localStorage.getItem('token')
          }
        })
            .then(function (res) {
              self.job_options = res.data.data
            })
        }
      },
      tabSelect(tab){
        if(tab =='follow')
          this.addFlag = true;
        else
          this.addFlag = false;
        if(tab =='activity')
          this.addFlagActivity = true;
        else
          this.addFlagActivity = false;
      }
  },
  watch : {
      followUpJob: _.debounce(function(addr) { this.jobSearch(addr) }, 500),
      inputs (val){
        let option_val = [];
        val.forEach(element => {
          if(element.name != '')
            option_val.push(element.name)
        });
      },
      inputs_activity (val){
        let option_val = [];
        val.forEach(element => {
          if(element.name != '')
            option_val.push(element.name)
        });
      },
      inputs_follow (val){
        let option_val = [];
        val.forEach(element => {
          if(element.name != '')
            option_val.push(element.name)
        });
      }

  },
}
</script>

<style>
table.dataTable.dtr-column>tbody>tr>td.control:before {
  font-family: "Font Awesome 5 Free" !important;
  font-weight: 900; content: "\f13a "!important;
  background-color: white !important;
  color: #6495ED !important;
  box-shadow: none !important;
  border : none !important;
  cursor: pointer;
  line-height: 16px !important;
}
table.dataTable.dtr-column>tbody>tr.parent td.control:before {
    content: '\f139' !important;
    color: #d33333 !important;
    line-height: 16px !important;
}
.multiselect__tag {
      background: #6495ED !important;
}
.multiselect__option--highlight {
      background: #6495ED !important;
}
.multiselect__option--highlight:after {
  background: #6495ED !important;
}
.multiselect__tag-icon:focus,.multiselect__tag-icon:hover {
  background: #6495ED !important;
}
.md-theme-default a:not(.md-button):hover {
    color: white;
}
a {
    text-decoration: inherit !important;
}
.nav-pills .nav-link.active, .nav-pills .show > .nav-link {
    color: #fff;
    background-color: #48AEA6 !important;
}
.wd-resolve-followup-note img {
    height: 36px;
    width: 36px;
    border-radius: 100%;
    padding: 2px;
    border: 1px solid #9E9E9E;
}
.job-select-div .multiselect__content-wrapper {
    /*position:absolute;*/
    display: block;
    background: #fff;
    max-height: 240px;
    overflow-y: auto;
    overflow-x: hidden;
    border: 1px solid #e8e8e8;
    border-top: none;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    z-index: 50;
    -webkit-overflow-scrolling: touch
  }
  .job-select-div .multiselect__element .multiselect__option{
    display: block;
    padding: 12px;
    min-height: 40px;
    line-height: 16px;
    width: 200px;
    text-decoration: none;
    text-transform: none;
    vertical-align: middle;
    position: relative;
    cursor: pointer;
    word-wrap: break-word;
    white-space: break-spaces;
  }
  .contact-job-select-div .multiselect  {
    z-index: 50;
  }
  .activity-job-select-div .multiselect  {
    z-index: 51;
  }
  .contact-job-select-div .multiselect__content-wrapper {
    /*position:absolute;*/
    display: block;
    background: #fff;
    max-height: 240px;
    overflow-y: auto;
    overflow-x: hidden;
    border: 1px solid #e8e8e8;
    border-top: none;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    z-index: 50;
    -webkit-overflow-scrolling: touch
  }
  .contact-job-select-div .multiselect__element .multiselect__option{
    display: block;
    padding: 12px;
    min-height: 40px;
    line-height: 16px;
    width: 200px;
    text-decoration: none;
    text-transform: none;
    vertical-align: middle;
    position: relative;
    cursor: pointer;
    word-wrap: break-word;
    white-space: break-spaces;
  }
</style>
